import styled from 'styled-components';

export const DrawerWrapper = styled.div`
  background: #fff;
  box-shadow: 4px 0 16px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  display: ${(props) => (props.expanded ? 'block' : 'none')};
  height: 100%;
  left: ${(props) => (props.expanded ? '386px' : '-114px')};
  overflow: scroll; /* this has to be scroll, not auto, for momentum scrolling to work */
  overscroll-behavior: contain;
  padding: 30px;
  position: absolute;
  text-align: center;
  transition: all 300ms ease-out;
  width: 500px;
  z-index: 3;

  a:hover {
    text-decoration: none;
  }

  @media (max-width: 970px) {
    bottom: ${(props) => (props.expanded ? '0' : '-1000px')};
    height: 100%;
    left: 5%;
    overscroll-behavior: auto;
    padding: 20px 0;
    right: 5%;
    width: 90%;
    z-index: ${(props) => (props.expanded ? '5' : '0')};
    margin-bottom: 20px;

    @supports (-webkit-overflow-scrolling: touch) {
      /* CSS specific to iOS devices */
      -webkit-overflow-scrolling: touch; /* this has to be included for momentum scrolling to work */
    }
  }
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  padding: 0 0 15px 0;

  @media (max-width: 970px) {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    padding: 0 20px 20px 20px;
  }
`;

export const HeaderTitle = styled.h4`
  color: #1277c6;
  display: none;
  font-size: 17px;
  margin: 0;

  @media (max-width: 970px) {
    display: block;
  }
`;

export const HeaderClose = styled.a`
  background: url('/public-assets/images/interactive-floorplan/x.svg') center
    center no-repeat;
  background-size: 24px auto;
  cursor: pointer;
  display: block;
  height: 44px;
  overflow: hidden;
  margin-left: auto;
  opacity: 0.7;
  text-indent: -1000em;
  transition: all 300ms ease-out;
  width: 44px;

  :hover {
    opacity: 1;
  }
`;

export const Image = styled.img`
  display: block;
  margin-bottom: 30px;
  max-width: 580px;
  width: 100%;

  @media (max-width: 970px) {
    margin: 0 auto 20px auto;
    width: calc(100% - 40px);
  }
`;

export const CtaWrapper = styled.div`
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0 5px 5px 0;
  display: flex;
  flex-direction: row;
  height: 100px;
  margin: 40px auto 80px auto;
  max-width: 350px;
  text-align: left;
  width: 100%;

  @media (max-width: 970px) {
    margin: 30px auto;
    max-width: 410px;
    width: calc(100% - 40px);
  }
`;

export const CtaLeft = styled.div`
  background-image: url(${(props) => props.img});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 5px 0 0 5px;
  width: 100px;
`;

export const CtaRight = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  padding: 0 15px 0 20px;
`;

export const CtaTitle = styled.div`
  color: #77787b;
  font-size: 13px;
  font-weight: bold;
  margin: 0;
`;

export const CtaText = styled.span`
  color: 77787B;
  font-size: 11px;
  font-weight: normal;
  display: inline-block;
  padding: 6px 0;
`;

export const CtaLink = styled.a`
  color: #1277c6;
  font-size: 13px;
  font-weight: bold;
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

export const MobileSecondaryClose = styled.a`
  color: #1277c6;
  display: none;
  font-size: 13px;
  font-weight: bold;
  margin: 20px 0 30px 0;
  padding: 5px;
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }

  @media (max-width: 970px) {
    display: inline-block;
  }
`;
